export default __webpack_public_path__ + "static/datafund@2x-04dcb4147f07b64ee97d7a37827729a2.png";